import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import Grid from "../Grid";
import Box from "../Box";
import Text from "../Text";
import HoverText from "../HoverText";
import styled from "styled-components";
import { useThemeDefaults } from "../utils";
import { focusVisibleStyle } from "../focus";
export var Insight = useThemeDefaults(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    alignItems: "start",
    pr: theme.insights.insight.pr
  };
}, styled(Box).withConfig({
  displayName: "Insights__Insight",
  componentId: "sc-3k5cg6-0"
})(["&:first-child > *{border-top:none;}@media (min-width:", "px){&:nth-child(2) > *{border-top:none;}}"], function (props) {
  return props.theme.breakpoints.sm;
}));
export var Icon = useThemeDefaults(function (_ref2) {
  var theme = _ref2.theme;
  return {
    minWidth: theme.insights.icon.size,
    width: theme.insights.icon.size,
    height: theme.insights.icon.size,
    mt: theme.insights.icon.mt
  };
}, Box);
export var Content = useThemeDefaults(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
    justifyContent: "start",
    ml: theme.insights.content.ml,
    pt: theme.insights.content.pt,
    pb: theme.insights.content.pb,
    pr: theme.insights.content.pr,
    overflow: "hidden",
    height: "100%",
    width: "100%",
    borderTop: theme.insights.content.borderBottom,
    borderColor: theme.insights.content.borderColor
  };
}, styled(Box).withConfig({
  displayName: "Insights__Content",
  componentId: "sc-3k5cg6-1"
})(["", " &:hover,&:focus-visible{", "{color:", " !important;}}"], focusVisibleStyle, HoverText, function (props) {
  return props.theme.colors.ctrl;
}));
export var Date = useThemeDefaults(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.insights.date.color,
    textStyle: theme.insights.date.textStyle,
    textTransform: "upperCase",
    mb: theme.insights.date.mb
  };
}, Text);
export var Title = useThemeDefaults(function (_ref5) {
  var theme = _ref5.theme;
  return {
    textStyle: theme.insights.title.textStyle,
    width: "100%",
    whiteSpace: "normal"
  };
}, Text);
export var Highlight = useThemeDefaults(function (_ref6) {
  var theme = _ref6.theme;
  return {
    as: "span",
    textStyle: theme.insights.highlight.textStyle,
    color: "inherit"
  };
}, Text);
export var Insights = function Insights(_ref7) {
  var props = _extends({}, _ref7);

  return /*#__PURE__*/React.createElement(Grid, _extends({
    gridTemplateColumns: ["minmax(0, 1fr)", "repeat(2, minmax(0, 1fr))"]
  }, props));
};
Insights.Insight = Insight;
Insights.Icon = Icon;
Insights.Content = Content;
Insights.Date = Date;
Insights.Title = Title;
Insights.Title.Highlight = Highlight;
export default Insights;